export { default } from './withStyles';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/styles/esm/withStyles/index.js
// module id = 239
// module chunks = 0